import { Dialog } from "primereact/dialog";
import { MultiSelect } from "primereact/multiselect";
import { useEffect, useRef, useState } from "react";
import { IBranchMastDropdown } from "../../models/IDropdown";
import { Fetch } from "../../shared/Fetch";
import { Button } from "primereact/button";
import { ITeamSkillMast } from "../../models/ISkillTeamManagement";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

interface IProps {
    open: boolean,
    singleData: ITeamSkillMast,
    hideDialog: () => void,
    toast: any,
}

interface GetBranches {
    id?: number,
    team_ID?: number,
    branch_ID?: number,
    branch_Name?: string,
    added_By?: number,
    added_On?: Date | string | null,
}

export const AllocationBranch = (props: IProps) => {
    const [selectedBranch, setSelectedBranch] = useState<number[]>([]);
    const [branches, setBranches] = useState<Array<IBranchMastDropdown>>();
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<GetBranches>, loading: boolean });
    const dt = useRef<any>(null);

    const loadBranches = async () => {
        const response = await Fetch("Dropdown/branches", "GET", null, null, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            setBranches(data);
        }
    }

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Team_Skill_Mast/getBranch", "GET", null, `team_id=${props.singleData.team_ID}`, null);
        if (response) {
            const data: Array<any> = await response.json();
            setTableData({ tableData: data, loading: false });
        } else {
            setTableData({ tableData: tableData.tableData, loading: false });
        }
    }

    const onSubmit = async () => {
        const response = await Fetch("Team_Skill_Mast/setBranch", "POST", { branches: selectedBranch }, `team_id=${props.singleData.team_ID}`, null);
        if (response) {
            setSelectedBranch([]);

            props.toast.current.show({ severity: 'success', detail: "Branches", life: 3000 });
            // onHide();
             setSelectedBranch([]);
            loadTableData();
        }
    };

    const action = async (rowData: any) => {
        return <Button icon="pi pi-sitemap" className="p-button-rounded text-primary bg-white border-none" onClick={() => removeBranch(rowData.id)} />
    };

    const removeBranch = async (id: number) => {
        const response = await Fetch("Team_Skill_Mast/removeBranch", "GET", null, `id=${id}`, null);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: "Branches", life: 3000 });
            // onHide();
            loadTableData();
        }
    }

    const onHide = () => {
        setSelectedBranch([]);
        props.hideDialog();
    }

    useEffect(() => {
        if (props.open) {
            loadBranches();
            loadTableData();
            setSelectedBranch([]);

        };
    }, [props.open]);

    return (
        <>
            <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit  Team Skill" modal className="p-fluid" onHide={onHide}>
                <MultiSelect value={selectedBranch} onChange={(e) => setSelectedBranch(e.value)} options={branches} optionValue="branch_ID" optionLabel="branchName" display="chip" filter placeholder="Select Branches" maxSelectedLabels={10} className="w-11" />
                <Button className="w-7rem h-4" label="SAVE" type="button" onClick={onSubmit}></Button>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                    ref={dt} size="small" stripedRows scrollable scrollHeight="75vh"
                    value={tableData.tableData}
                    emptyMessage="No Data found."
                    // header={header}
                    loading={tableData.loading}
                >
                    <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                    <Column field="branch_Name" header="Branch" />
                    <Column field="" header="Action" body={(rowData) => <Button icon="pi pi-trash" className="p-button-rounded text-primary bg-white border-none" onClick={() => removeBranch(rowData.id)} />} />
                </DataTable>
            </Dialog>
        </>
    );
}